// This file is auto-generated by @hey-api/openapi-ts

export const CustomerAccountLinkTypesEnum = {
    REGISTERED: 'REGISTERED',
    ASSIGNED: 'ASSIGNED',
    MANAGED: 'MANAGED',
    ANONYMOUS: 'ANONYMOUS'
} as const;

export type CustomerAccountLinkTypesEnum = typeof CustomerAccountLinkTypesEnum[keyof typeof CustomerAccountLinkTypesEnum];
